<template>
  <div class="course-introduce-container">
    <div class="book-name">{{ detail.courseTitle }}</div>
    <div v-if="detail.coursewareDemoVideoUrl" class="section">
      <div class="title">
        <div class='title-icon' />
        <span class="title-text">教学视频</span>
      </div>
      <video :src="detail.coursewareDemoVideoUrl" :poster="detail.coursewareDemoVideoUrl + '?vframe/jpg/offset/1'" controls  class="video"/>
    </div>
    <div class="section">
      <div class="title">
        <div class='title-icon' />
        <span class="title-text">课程教案</span>
      </div>
      <img v-for="(item, index) in detail.introduceUrlList" :key="index" :src="item" class="image" @click="preview(index)">
    </div>
  </div>
</template>

<script>
import { api } from '@/api/index'
import { ImagePreview } from 'vant'

export default {
  name: 'CourseIntroduce',
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      bookCoursewareId: '',
      detail: {}
    }
  },
  created() {
    this.bookCoursewareId = this.$route.query.id
    this.getDetail()
  },
  methods: {
    getDetail() {
      api.getCourseIntroduce({
        bookCoursewareId: this.bookCoursewareId
      }).then(res => {
        if (res.code === 10000) {
          this.detail = res.data
        } else {
          this.$toast.fail(res.message)
        }
      })
    },
    preview(index) {
      ImagePreview({
        images: this.detail.introduceUrlList,
        startPosition: index,
        loop: false
      })
    }
  }
}
</script>

<style scoped>
.course-introduce-container{
  width: 100%;
}

.book-name{
  width: 100%;
  font-size: 16px;
  text-align: center;
  line-height: 25px;
  background-color: #f6f7f8;
  padding: 10px 30px;
  box-sizing: border-box;
}

.section{
  width: 100%;
  background-color: #f6f7f8;
  margin-top: 20px;
  text-align: center;
  padding-bottom: 20px;
}

.video{
  max-width: 414px;
  width: 90%;
}

video:focus{
  outline: -webkit-focus-ring-color auto 0;
}

.image{
  max-width: 414px;
  width: 90%;
  display: block;
  margin: 10px auto;
}

/* 模块标题 */

.title {
  width: 100%;
  height: 50px;
  position: relative;
  text-align: left;
}

.title-text {
  color: #000;
  font-weight: 700;
  line-height: 50px;
  font-size: 16px;
  margin-left: 20px;
}

.title-icon {
  position: absolute;
  top: 50%;
  left: 10px;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  border-radius: 2px;
  background-color: #00c553;
}
</style>